/* global _pafw_payment_blocks */

import { useEffect } from 'react';
import { pafwProcessPayment } from './pafw';
import { decodeEntities } from '@wordpress/html-entities';

export const PafwEximbayContent = ( props ) => {
    const { eventRegistration, emitResponse, settings } = props;
    const { onCheckoutSuccess } = eventRegistration;

    useEffect( () => {
        const checkoutSuccess = onCheckoutSuccess( async( obj ) => {
            return pafwProcessPayment( props, obj );
        } );
        return () => {
            checkoutSuccess()
        };
    }, [
        emitResponse.responseTypes.ERROR,
        emitResponse.responseTypes.SUCCESS,
        onCheckoutSuccess
    ] );

    return (<div>
        <p>{decodeEntities( props.settings.description || '' )}</p>
        <select id="iamport_eximbay-pay-method" className="input-text wc-credit-card-form-pay-method" autoComplete="off" name="iamport_eximbay-pay-method'">
            <option value="card">CreditCard</option>
            <option value="unionpay">UnionPay</option>
            <option value="alipay">Alipay</option>
            <option value="wechat">WechatPay</option>
            <option value="molpay">Molpay</option>
            <option value="econtext">EContext(일본편의점결제)</option>
        </select>
    </div>);
};